import React from 'react'

const HeadlineCard = props => {
  const img = require(`../../img/${props.illo}`).default

  return (
    <div className='headline-wrapper'>
      <div className='top-illo'>
        <img src={img} alt='top illustration'></img>
      </div>
      <div className='headline-text-wrapper'>
        <div className='article-wrapper'>
          <div className='goal-wrapper'>
            <div className='goal'> {props.goal}</div>
          </div>
          <div className='head-wrapper'>
            <h2>{props.subhead}</h2>
            <h1>{props.headline}</h1>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeadlineCard
